import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Volume1 = createReactComponent("Volume1", ["svg", defaultAttributes, [["polygon", {
  points: "11 5 6 9 2 9 2 15 6 15 11 19 11 5",
  key: "m3abqr"
}], ["path", {
  d: "M15.54 8.46a5 5 0 010 7.07",
  key: "az8w0d"
}]]]);
export default Volume1;